import { FormControl } from '@angular/forms';

import { Media } from '@eiq/files/models';
import { ImageFit, QuestionType } from '@empathy/survey/base';
import { MediaForm, Question } from '@empathy/survey-core';

import { QuestionForm } from './question-form.model';

export class QuestionFormHeatmap extends QuestionForm {
  constructor() {
    super();
    this.extendFormGroup();
  }

  initEmpty(nextId: number, pageId: string): void {
    super.initEmpty(nextId, pageId);
    this.form.get('type').setValue(QuestionType.Heatmap);
  }

  init(question: Question): void {
    super.init(question);
    this.patchHeatmapImage(question.imageHeatmap);
  }

  private extendFormGroup(): void {
    this.form.addControl('imageHeatmap', new MediaForm().form);
    this.form.addControl('imageWidth', new FormControl<number>(300));
    this.form.addControl('imageHeight', new FormControl<number>(400));
    this.form.addControl('imageFit', new FormControl<ImageFit>('contain'));
    this.form.addControl('maxLength', new FormControl<number>(0));
    this.form.addControl('minLength', new FormControl<number>(0));
  }

  private patchHeatmapImage(heatmapImage: Media): void {
    this.form.get('imageHeatmap').patchValue(heatmapImage);
  }
}
